import React, { useState } from "react";

const ServiceFaq: React.FC = () => {
  const [active, setActive] = useState<number>(1);

  const toggleAccordion = (index: number) => {
    setActive(active === index ? -1 : index);
  };

  // Service Process Steps
  const faqItems = [
    {
      id: 1,
      title: "01. User registration",
      content:
        "User creates an account on the crypto exchange platform by entering personal details, verifying email, and completing KYC if required.",
    },
    {
      id: 2,
      title: "02. Wallet creation & funding",
      content:
        "A wallet is automatically generated for the user. They can add funds using bank transfer, credit/debit card, or cryptocurrency deposit.",
    },
    {
      id: 3,
      title: "03. Buying cryptocurrency",
      content:
        "Users place buy orders for cryptocurrencies. Purchased coins are stored securely in the user's exchange wallet.",
    },
    {
      id: 4,
      title: "04. Order matching engine",
      content:
        "The exchange’s order-matching engine pairs buy orders with sell orders in real-time, ensuring liquidity and fair pricing.",
    },
    {
      id: 5,
      title: "05. Transfer upon conditions",
      content:
        "Crypto is transferred when all predefined conditions are met, including market price, order type, and wallet verification.",
    },
    {
      id: 6,
      title: "06. Foreign currency/crypto purchase",
      content:
        "Once crypto is sold, the user can purchase foreign currency or another cryptocurrency using the sale proceeds.",
    },
    {
      id: 7,
      title: "07. Funds received into bank",
      content:
        "Finally, the user withdraws fiat currency into their preferred bank account, completing the transaction lifecycle.",
    },
  ];

  return (
    <div className="service-process-wrap pt-120 pb-125">
      <div className="row mt-none-50 align-items-center">
        
        {/* LEFT SIDE: ACCORDION */}
        <div className="col-lg-6 mt-50">
          <h2 className="details-content-title mb-40">Service process</h2>

          <div className="service_process_faq">
            <div className="accordion">
              {faqItems.map((item) => (
                <div className="accordion-item" key={item.id}>
                  <div
                    className={`accordion-button ${
                      active === item.id ? "" : "collapsed"
                    }`}
                    role="button"
                    onClick={() => toggleAccordion(item.id)}
                  >
                    {item.title}
                  </div>

                  <div
                    className={`accordion-collapse collapse ${
                      active === item.id ? "show" : ""
                    }`}
                  >
                    <div className="accordion-body">
                      <p className="m-0">{item.content}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* RIGHT SIDE: CLICKABLE PROCESS GRAPHIC LIST */}
        <div className="col-lg-6 mt-50">
          <ul className="content_layer_group list-unstyled">
            {faqItems.map((item) => (
              <li
                key={item.id}
                onClick={() => toggleAccordion(item.id)}
                className={active === item.id ? "active" : ""}
              >
                <span>{item.title.replace(/^\d+\.\s/, "")}</span>
              </li>
            ))}
          </ul>
        </div>

      </div>
    </div>
  );
};

export default ServiceFaq;
